package location

import kotlinx.coroutines.flow.Flow
import model.GeoPoint
import kotlin.time.Duration.Companion.seconds

// How long to wait for a position once permission is granted; the permission prompt itself is not timed
val LOCATION_FIX_TIMEOUT = 10.seconds

interface GeoLocation {
    suspend fun current(): GeoPoint

    val updates: Flow<GeoPoint>

    suspend fun start()
    fun stop()

    // Only Android and iOS can send the user to the app's settings screen
    val canOpenSettings: Boolean get() = false
    fun openSettings() {}
}
